import en from './messages_en';
import es from './messages_es';

export default {
    'en': en,
    'es': es,
};
